export const hasAntiSocialForcesOptions = {
  YES: 1,
  NO: 0
}
